package com.essntl.core.quickbooks.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksItemRequest(
    val Name: String,
    val Type: String = "Service",
    val IncomeAccountRef: AccountRef,
    val ParentRef: AccountRef?,
    @SerialName("SubItem")
    val subItem: Boolean,
) {
    @Serializable
    data class AccountRef(
        val name: String? = null,
        val value: String
    )
}
